import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/enrols.action'
import { ActionWithPayload } from 'helpers/redux-actions.helper'
import adminApplicationsList, {
  Query,
} from 'api/administration/applications/List'

function getList(q?: Query) {
  return adminApplicationsList(q)
}

const pattern = fromActions.ENROL_ADMIN_LIST_GET

export type EnrolAdminListAction = ActionWithPayload<
  typeof pattern,
  {
    q?: Query
  }
>

function* enrolAdminListEffectSaga(action: EnrolAdminListAction) {
  try {
    const { payload } = action
    const data = yield call(getList, payload?.q)
    yield put(fromActions.Actions.enrolAdminListSuccess(data))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* enrolAdminListWatcherSaga() {
  yield takeLatest(pattern, enrolAdminListEffectSaga)
}
